import type { TMainNavItem } from "@/app/[locale]/(home)/_components/nav/nav"

// TODO Consider splitting this into mainNavConfig and footerNavConfig

export const mainNavConfig: TMainNavItem[] = [
  // {
  //   title: 'Blog',
  //   href: '/blog',
  // },
  // {
  //   title: 'About',
  //   href: '/about',
  // },
  // {
  //   title: 'Tech Stack',
  //   href: '/tech-stack',
  // },
  // {
  //   title: 'Hardware',
  //   href: '/hardware',
  // },
  // {
  //   title: 'n8n',
  //   href: '/n8n',
  // },
  // {
  //   title: 'Consulting Services',
  //   href: '/consulting-services',
  // },
  // {
  //   title: 'GitHub',
  //   href: config.links.github,
  //   external: true,
  // },
  // {
  //   title: 'Twitter',
  //   href: config.links.twitter,
  //   external: true,
  // },
  // {
  //   title: 'LinkedIn',
  //   href: config.links.linkedin,
  //   external: true,
  // },
] as const

export type TMainNavConfig = typeof mainNavConfig
